import { api, type ApiResponse } from './api';
import type {
  ScheduleVerificationResponse,
  SchedulesVerificationSummaryGlobal,
} from '@/types/api';

export const schedulesVerificationService = {
  /**
   * Fuerza verificación plataforma vs dispositivo para una controladora.
   */
  async verify(
    controllerId: string,
    force = false
  ): Promise<ApiResponse<ScheduleVerificationResponse>> {
    const qs = force ? '?force=true' : '';
    return api.post<ScheduleVerificationResponse>(
      `/controllers/${controllerId}/schedules/verify${qs}`
    );
  },

  /**
   * Estado de verificación actual sin forzar consulta al dispositivo.
   */
  async getStatus(
    controllerId: string
  ): Promise<ApiResponse<ScheduleVerificationResponse>> {
    return api.get<ScheduleVerificationResponse>(
      `/controllers/${controllerId}/schedules/verification-status`
    );
  },

  /** Dispara verificación masiva (background). */
  async verifyAll(): Promise<ApiResponse<{ status: string; message?: string }>> {
    return api.post<{ status: string; message?: string }>('/schedules/verify-all');
  },

  /** Resumen global de verificación en el servidor. */
  async getGlobalSummary(): Promise<ApiResponse<SchedulesVerificationSummaryGlobal>> {
    return api.get<SchedulesVerificationSummaryGlobal>('/schedules/verification-summary');
  },
};

export default schedulesVerificationService;
